var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.6,7.4L1.1,0.1C0.5-0.1-0.1,0.3,0,1l2.1,5.5L10.9,8L2.1,9.5L0,15c-0.1,0.7,0.5,1.1,1.1,0.9l14.4-7.3\n\tC16.1,8.4,16.1,7.6,15.6,7.4z","fill":"currentColor"}));
}

Send.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Send;

Send.default = Send;
